export default __webpack_public_path__ + "static/media/15.6cd00b29.jpg";